export default __webpack_public_path__ + "static/media/project1_mockup.c7117cf8.png";